//================================================================
//  Page: My Requests
//================================================================

//  Purpose: This page shows all Procurement requests assigned to the current user

//================================================================


// Libraries
import React, { useReducer } from 'react';

// Contexts

// Components
import PageComponent from '../../Components/PageComponent/PageComponent';
import TabView from '../../Components/TabView/TabView';

// Tabs
import InProgress from './Tabs/InProgress';
import Completed from './Tabs/Completed';
import Cancelled from './Tabs/Cancelled';
import All from './Tabs/All';

// Functions

// Images

// CSS
import './MyTasks.css';


export default function MyTasks() {

  //------------------------------------------------------
  //  useReducer
  //------------------------------------------------------

  // Used to store the total requests per stage/view
  const [requests, setRequests] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      'inProgressRequests': [],
      'inProgressRequestsFiltered': [],
      'completedRequests': [],
      'completedRequestsFiltered': [],
      'cancelledRequests': [],
      'cancelledRequestsFiltered': [],
      'allRequests': [],
      'allRequestsFiltered': [],
    }
  );

  //------------------------------------------------------
  //  HTML
  //------------------------------------------------------

  return (
    <PageComponent
      body={
        <TabView
          defaultView={1}

          //------------------------------------------------------
          //  In Progress
          //------------------------------------------------------

          oneTitle={
            <div className='flex flex-row gap-2'>
              In Progress
            </div>
          }
          oneRoute={'/myrequests?view=inprogress'}
          oneContent={
            <InProgress
              requests={requests}
              setRequests={setRequests}
            ></InProgress>
          }

          //------------------------------------------------------
          //  Completed
          //------------------------------------------------------

          twoTitle={'Completed'}
          twoRoute={'/myrequests?view=completed'}
          twoContent={
            <Completed
              requests={requests}
              setRequests={setRequests}
            ></Completed>
          }

          //------------------------------------------------------
          //  Cancelled
          //------------------------------------------------------

          threeTitle={'Cancelled'}
          threeRoute={'/myrequests?view=cancelled'}
          threeContent={
            <Cancelled
              requests={requests}
              setRequests={setRequests}
            ></Cancelled>
          }

          //------------------------------------------------------
          //  All
          //------------------------------------------------------

          fourTitle={'All'}
          fourRoute={'/myrequests?view=all'}
          fourContent={
            <All
              requests={requests}
              setRequests={setRequests}
            ></All>
          }

        ></TabView>
      }
    ></PageComponent>
  )
}
